import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  //扩容通道
  getChanLists({ commit }, params) {
    return api.expansionDemo
      .getChan(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_OFFCHAIN_CHAN_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },

  //扩容通道交易列表
  getTxLists({ commit }, params) {
    return api.expansionDemo
      .getTxList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_OFFCHAIN_TX_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },

  //扩容通道内交易列表
  getChanTxLists({ commit }, params) {
    return api.expansionDemo
      .getChanTxList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_OFFCHAIN_CHAN_TX_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
